import { render, staticRenderFns } from "./createManagement.vue?vue&type=template&id=61ba63e6&scoped=true&"
import script from "./createManagement.vue?vue&type=script&lang=js&"
export * from "./createManagement.vue?vue&type=script&lang=js&"
import style0 from "./createManagement.vue?vue&type=style&index=0&id=61ba63e6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61ba63e6",
  null
  
)

export default component.exports